import { EL_TIGER_AI_HELP } from '@/core/config/externalLinks'
import styles from './style.module.scss'
import { t } from '@lingui/macro'
import { TgChatBot } from '@/assets/svg/otherIcons/TgChatBot'

const TgBotButton = () => {
  const handleClick = () => {
    window.open(EL_TIGER_AI_HELP)
  }

  return (
    <div className={styles.container} onClick={handleClick}>
      <div className={styles.iconWrapper}>
        <TgChatBot className={styles.icon} />
        <div className={styles.text}>{t({ id: 'tgBotButton.text' })}</div>
      </div>
    </div>
  )
}

export default TgBotButton
